import { render, staticRenderFns } from "./MessageEditorWrapper.vue?vue&type=template&id=13d5f7d4&scoped=true"
import script from "./MessageEditorWrapper.vue?vue&type=script&setup=true&lang=js"
export * from "./MessageEditorWrapper.vue?vue&type=script&setup=true&lang=js"
import style0 from "./MessageEditorWrapper.vue?vue&type=style&index=0&id=13d5f7d4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13d5f7d4",
  null
  
)

export default component.exports